import React, { Suspense } from 'react';

const PaymentAlertComponent = React.lazy(() => import("../Component/PaymentAlertComponent/PaymentAlertComponent"))

function PaymentAlertPage(props) {
    return (
        <>
            <Suspense fallback={<div>Loading...</div>}>
                <PaymentAlertComponent />
            </Suspense>
        </>
    );
}

export default PaymentAlertPage;